export const pathsSummary = {
  alerts: {
    default: [''],
    agsus: [''],
  },
  alertProfile: {
    default: [''],
    agsus: [''],
  },
}
